
namespace TabAurous.Inventory {

    @Serenity.Decorators.registerClass()
    export class OpeningStockLaborDialog extends Common.GridEditorDialog<OpeningStockLaborRow> {
        protected getFormKey() { return OpeningStockLaborForm.formKey; }
        //protected getIdProperty() { return OpeningStockLaborRow.idProperty; }
        protected getLocalTextPrefix() { return OpeningStockLaborRow.localTextPrefix; }
        //protected getNameProperty() { return OpeningStockLaborRow.nameProperty; }
        //protected getService() { return OpeningStockLaborService.baseUrl; }
        protected getDeletePermission() { return OpeningStockLaborRow.deletePermission; }
        protected getInsertPermission() { return OpeningStockLaborRow.insertPermission; }
        protected getUpdatePermission() { return OpeningStockLaborRow.updatePermission; }

        protected form = new OpeningStockLaborForm(this.idPrefix);

    }
}